// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen5_comp__JydQ_"};